import JobWorkerInterviewStatus from "@/models/JobWorkerInterviews/JobWorkerInterviewStatus";
import JobWorkerInterviewType from "@/models/JobWorkerInterviews/JobWorkerInterviewType";
import JobScheduleEventType from "@/models/Jobs/JobScheduleEventType";

export default class JobScedhuleEventViewModel {
	interviewStatus: JobWorkerInterviewStatus = 0;
	jobId = '';
    jobTitle = '';
	jobWorkerId = '';
    workerName = '';
    contactName = '';
    companyName = '';
    locationName = '';
    startAt: string;
    endAt: string;
	interviewType: JobWorkerInterviewType = 0;
    interviewAddress = '';
    type: JobScheduleEventType;
}